export default __webpack_public_path__ + "f8e25c2ebeb0a0725a9ee6db4b5f1340.svg";